import React, { createContext, useContext, useState } from "react";

const CheckoutContext = createContext();

export const CheckoutProvider = ({ children }) => {
	const initialValue = 1; // Default minimum value for orderCount
	const [orderCount, setOrderCount] = useState(initialValue);

	// Function to increment the order count
	const incrementOrderCount = () => {
		setOrderCount((prevCount) => prevCount + 1);
	};

	// Function to decrement the order count
	const decrementOrderCount = () => {
		setOrderCount((prevCount) => (prevCount > initialValue ? prevCount - 1 : initialValue));
	};

	// Function to reset the order count to the initial value
	const resetOrderCount = () => {
		setOrderCount(initialValue);
	};

	// Expose all count-related state and operations
	return (
		<CheckoutContext.Provider value={{ orderCount, incrementOrderCount, decrementOrderCount, resetOrderCount }}>
			{children}
		</CheckoutContext.Provider>
	);
};

export const useCheckout = () => useContext(CheckoutContext);
